<template>
  <div class="right">
    <div class="right_title">
      <div class="right_title_ch">项目信息分析</div>
      <div class="right_title_en">Project information analysis</div>
    </div>
    <div class="right_tproject">
      <ul>
        <li>
          <!-- <p>223</p> -->
          <dv-digital-flop :config="projectSigning" style="width:90px;height:30px;" />
          <div>已签约</div>
        </li>
        <li>
          <!-- <p>33</p> -->
          <dv-digital-flop :config="projectRegister" style="width:90px;height:30px;" />
          <div>签约并注册</div>
        </li>
      </ul>
    </div>
    <div class="right_title">
      <div class="right_title_ch">总产值趋势分析</div>
      <div class="right_title_en">Total output trend analysis</div>
    </div>
    <div class="right_ttotal">
      <div class="right_ttotal_left">
        <div class="right_ttotal_left_title">总产值</div>
        <dv-digital-flop :config="projectTotal" style="width:100%;height:30px; margin-top: 5px;" />
      </div>
      <div class="right_ttotal_right">
        <dv-charts :option="option" />
      </div>
    </div>
    <div class="right_title">
      <div class="right_title_ch">产业结构分析</div>
      <div class="right_title_en">Real-time vehicle information</div>
    </div>
    <div class="right_tcy">
      <div class="right_tinfo_chart">
        <dv-charts :option="optionBar" />
      </div>
      <div class="right_tcompony">
        <div class="right_tcompony_title">某某财产保险股份有限公司</div>
        <div class="right_tcompony_cont">
          <span>项目需求</span>
          将国任财产保险股份有限公司保定中心支公司迁进深圳园，提供财产保险、科技保险、投资资管等服务产品，办理财产保险、科技保险、投资资管等业务
        </div>
        <div class="right_tcompony_cont">
          <span>空间需求</span>
          将国任财产保险股份有限公司保定中心支公司迁进深圳园，提供财产保险、科技保险、投资资管等服务产品，办理财产保险、科技保险、投资资管等业务。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// right - 日常管理

export default {
  name: "BottomTab",
  components: {},
  data() {
    return {
      // 已签约
      projectSigning: {
        number: [13],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      // 签约并注册
      projectRegister: {
        number: [13],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      // 总产值
      projectTotal: {
        number: [13],
        content: "{nt}",
        style: {
          fontSize: 22,
          fill: '#c97c0e',
          fontWeight: 'bold'
        }
      },
      option: {
        // 图例
        legend: {
          show: true,
          data: ['产值占比', '效率占比'],
          top: 30,
          textStyle: {
            fontFamily: 'Arial',
            fontSize: 13,
            fill: '#fff'
          }
        },
        xAxis: {
          data: [
            "11.1",
            "11.2",
            "11.3",
            "11.4",
            "11.5",
            "11.6",
            "11.7",
          ],
          axisLabel: {
            // 配置轴刻度说明
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: true, // 设置x轴线显示
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: false,
          },
          interval: 2,
        },
        yAxis: {
          // name: "%",
          data: "value",
          nameTextStyle: {
            fill: "#fff",
            fontSize: 10,
          }, // 标题样式
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: true, //设置y轴线
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: false, // 不显示刻度
          },
          splitLine: {
            // y轴中间线是否显示
            show: false
          },
        },
        series: [
          {
            name: "产值占比",
            data: [20, 30, 26, 25, 40, 50, 36],
            type: "line",
            smooth: true,
            lineArea: {
              // 设置折线阴影
              show: true,
              gradient: ["rgba(201, 121, 14, 0.6)", "rgba(55, 162, 218, 0)"],
            },
          },
          {
            name: "效率占比",
            data: [50, 44, 36, 20, 58, 45, 36],
            type: "line",
            smooth: true,
            lineArea: {
              // 设置折线阴影
              show: true,
              gradient: ["rgba(24, 114, 225, 0.3)", "rgba(55, 162, 218, 0)"],
            },
          },
        ],
        color: ["#c97c0e", "#1890FF"], // 折线颜色
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "20px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
        linePoint: {
          show: false,
        },

      },
      optionBar: {
        xAxis: {
          // name: '第一周',
          data: ['高端装备制造', '', '新一代信息技术', ''],
          axisLabel: {
            // 配置轴刻度说明
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: true, // 设置x轴线显示
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          // name: '销售额',
          data: 'value',
          nameTextStyle: {
            fill: "#fff",
            fontSize: 10,
          }, // 标题样式
          axisLabel: {
            style: {
              fill: "#fff",
              fontSize: 10,
              rotate: 0,
            },
          },
          axisLine: {
            show: true, //设置y轴线
            style: {
              stroke: "#fff",
              lineWidth: 1,
            },
          },
          axisTick: {
            show: false, // 不显示刻度
          },
          splitLine: {
            // y轴中间线是否显示
            show: false
          },
        },
        series: [
          {
            data: [10, 20, 29, 10],
            type: 'bar',
          },
          {
            data: [10, 16, 30, 15],
            type: 'bar'
          }
        ],
        grid: {
          style: {
            fill: "rgba(0, 0, 0, 0)",
          },
          top: "20px",
          left: "10px",
          right: "10px",
          bottom: "20px",
        },
        color: ["#c97c0e", "#1890FF"], // 线的颜色
      }
    };
  },
  mounted() {
    this.updateHandler();
  },
  methods: {
    /* start(){
      setInterval(this.updateHandler, 5000)
    }, */
    updateHandler() {
      /**
       * 只是这样做是无效
       * config指向的内存地址没有发生变化
       * 组件无法侦知数据变化
       */
      this.projectSigning.number[0] = 223;
      this.projectRegister.number[0] = 33;
      this.projectTotal.number[0] = 5646

      /**
       * 使用ES6拓展运算符生成新的props对象
       * 组件侦知数据变化 自动刷新状态
       */
      this.projectSigning = { ...this.projectSigning };
      this.projectRegister = { ...this.projectRegister };
      this.projectTotal = { ...this.projectTotal };
    },
  },
};
</script>
<style lang="less">
.right_title {
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  width: 400px;
  font-family: sans-serif;
  display: flex;
  margin: 20px auto 0;
  background: url(../img/bg_rightline.png) center bottom no-repeat;

  .right_title_ch {
    position: relative;
    font-size: 18px;
    letter-spacing: 2px;
    color: #fff;
    font-weight: bold;
    width: 160px;
    flex-shrink: 0;
  }

  .right_title_ch::before {
    position: absolute;
    content: "";
    right: 0;
    top: 10px;
    width: 2px;
    height: 13px;
    background: #b3c4c9;
  }

  .right_title_en {
    font-size: 11px;
    letter-spacing: 1px;
    color: #b3c4c9;
    padding-left: 10px;
  }
}

.right_tcy {
  font-family: sans-serif;
  height: auto;
  overflow: hidden;
  margin: 0px auto;
  width: 400px;

  .right_tinfo_chart {
    height: 140px;
  }

  .right_tcompony {
    margin-top: 10px;

    .right_tcompony_title {
      background: url(../img/bg_compney.png) no-repeat;
      height: 27px;
      line-height: 27px;
      font-size: 15px;
      padding-left: 1px;
      color: #fff;
    }

    .right_tcompony_cont {
      height: auto;
      overflow: hidden;
      color: #fff;
      font-size: 13px;
      line-height: 33px;

      span {
        font-size: 14px;
        color: #c97c0e;
        margin-right: 10px;
      }
    }
  }
}

.right_ttotal {
  margin: 0px auto;
  width: 400px;
  height: 140px;
  overflow: hidden;
  display: flex;
  font-family: sans-serif;

  .right_ttotal_left {
    width: 100px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    flex-shrink: 0;

    .right_ttotal_left_title {
      font-size: 15px;
      color: #b3c4c9;
      height: 32px;
      line-height: 32px;
      text-align: center;
    }

    .right_ttotal_left_num {
      font-size: 22px;
      color: #c97c0e;
      height: 33px;
      line-height: 33px;
      margin-top: 5px;
      font-weight: bold;
    }
  }

  .right_ttotal_right {
    width: 300px;
    height: 140px;
  }
}

.right_tproject {
  height: auto;
  overflow: hidden;
  margin-top: 30px;

  ul,
  li,
  p {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  ul {
    margin: 0px auto;
    width: 400px;
    height: auto;
    display: flex;

    li {
      width: 180px;
      height: 72px;
      background: url(../img/bg_tproject.png) no-repeat;
      margin: 0 9px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      flex-wrap: wrap-reverse;

      p,
      div {
        text-align: center;
        width: 90px;
      }

      p {
        font-size: 22px;
        color: #C97C0E;
        font-weight: bold;
      }

      div {
        font-size: 13px;
        color: #B3C4C9;
      }
    }
  }
}
</style>
